import React, { useState } from "react";

const CustomToggleButton = ({ options, onChange, value, buttonStyle, radioContainerStyle }) => {
    return (
        <div style={{ display: "flex", gap: "8px" }}>
            {options.map((item) => (
                <button
                    key={item.value}
                    onClick={() => onChange(item.value)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "0 16px",
                        height: "40px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        fontWeight: "500",
                        cursor: "pointer",
                        border: `1px solid ${value === item.value ? "#3f3fbf" : "#ddd"}`,
                        backgroundColor: value === item.value ? "#f0efff" : "#fff",
                        color: value === item.value ? "#1D1C20" : "#666",
                        outline: "none",
                        ...buttonStyle
                    }}
                >
                    <span
                        style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: `2px solid ${value === item.value ? "#3f3fbf" : "#ddd"}`,
                            backgroundColor: value === item.value ? "#3f3fbf" : "transparent",
                            ...radioContainerStyle
                        }}
                    >
                        {value === item.value && (
                            <span
                                style={{
                                    width: "9px",
                                    height: "9px",
                                    borderRadius: "50%",
                                    backgroundColor: "#fff",

                                }}
                            />
                        )}
                    </span>
                    <span>

                        {item.label}
                    </span>
                </button>
            ))}
        </div>
    );
};

export default CustomToggleButton;
